import { useEffect } from 'react';
import { useRouter } from 'next/router';

import useCurrentSession from '@/utils/hooks/user/useCurrentSession';

import { SIGN_IN } from '@/lib/routes/publicRoutes';

import LoaderPage from '@/components/base/Loader/LoaderPage';

export default function Homepage() {
    const router = useRouter();
    const { user, isLoading } = useCurrentSession({ isLoggedRedirect: true });

    useEffect(() => {
        if (!isLoading && !user) {
            // Redirect to App Router signin page
            // Middleware will add locale prefix
            window.location.href = SIGN_IN;
        }
    }, [isLoading, user, router]);

    return <LoaderPage />;
}
